import React, { useState, useEffect, useContext } from 'react'
import {
  CCard,
  CCardBody,
  CCardHeader,
  CForm,
  CFormLabel,
  CFormInput,
  CRow,
  CCol,
  CFormSelect,
  CButton,
} from '@coreui/react'
import PropTypes from 'prop-types'
import { UserContext } from 'src/context/UserContext'
import { PuranoAbedanAPI } from './PuranoAbedanAPI'
import { CircularProgress } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { CONSTANTS } from 'src/constants'
import { convert_to_preeti } from 'src/helpers/PreetiConverter'

const initialState = {
  name: '',
  province: 1,
  status: 1,
  slug: null,
}

const PuranoAbedanForm = ({
  open,
  editMode,
  handleClose,
  editData,
  reload,
  setReload,
  fetching,
  selectedId,
}) => {
  // Response State
  const [response, setResponse] = useState({
    success: null,
    error: null,
  })
  // OldAnusuchi data
  const [puranoAbedanData, setPuranoAbedanData] = useState(initialState)

  // Lifecycle method to
  useEffect(() => {
    // console.log(editData)
    if (editData) {
      setPuranoAbedanData({
        name: editData.name,
        province: editData.province,
        slug: editData.slug,
        status: editData.status,
      })
    }
  }, [editData])

  useEffect(() => {
    if (open === false) {
      setResponse({
        success: null,
        error: null,
      })
    }
  }, [open])
  // User Context
  const [user] = useContext(UserContext)

  const [loading, setLoading] = useState(false)

  // function to handle oldAnusuchi data changes
  const handlepuranoabedanDataChange = (e) => {
    setPuranoAbedanData({ ...puranoAbedanData, [e.target.name]: convert_to_preeti(e.target.value) })
  }

  // Function to create OldAnusuchi
  const handleSubmit = (e) => {
    setLoading(true)
    e.preventDefault()
    {
      editMode
        ? PuranoAbedanAPI.editOldAnusuchi(user.access_token, puranoAbedanData, selectedId)
            .then((res) => {
              if (res.data.status === true) {
                setPuranoAbedanData(initialState)
                setResponse({
                  error: null,
                  success: 'OldAnusuchi has been updated',
                })
                setLoading(false)
              } else {
                console.log(res.data)
                setResponse({
                  error: 'Failed to update',
                  success: null,
                })
                setLoading(false)
              }
            })
            .catch((e) => console.log(e.message))
        : PuranoAbedanAPI.createOldAnusuchi(user.access_token, puranoAbedanData)
            .then((res) => {
              if (res.data.status === true) {
                setLoading(false)
                setPuranoAbedanData(initialState)
                setResponse({
                  error: null,
                  success: 'New OldAnusuchi has been created',
                })
                setReload(!reload)
              }
            })
            .catch((e) => console.log(e.message))

      setTimeout(
        () =>
          setResponse({
            success: null,
            error: null,
          }),
        CONSTANTS.ALERT_TIME_OUT,
      )
    }
  }

  return (
    <CCard className="mb-4">
      <CCardHeader>{editMode ? 'Edit OldAnusuchi' : 'नयाँ अदालत'}</CCardHeader>
      <CCardBody>
        {response.success ? <Alert severity="success">{response.success}</Alert> : null}
        {response.error ? <Alert severity="error">{response.error}</Alert> : null}

        {fetching ? (
          <CircularProgress />
        ) : (
          <CForm className={response.success || response.error ? 'mt-4' : null}>
            <CRow>
              <CCol md="12">
                <div className="mb-3">
                  <CFormLabel htmlFor="oldAnusuchiName">अदालत को नाम</CFormLabel>

                  <CFormInput
                    type="text"
                    id="oldAnusuchiName"
                    placeholder=""
                    name="name"
                    value={puranoAbedanData.name}
                    onChange={handlepuranoabedanDataChange}
                  />
                </div>
              </CCol>

              <CCol md="12">
                {loading ? (
                  <CircularProgress />
                ) : (
                  <CButton type="submit" color="primary" size="sm" onClick={handleSubmit}>
                    {editMode ? 'Save' : 'अदालत बनाउनुहोस'}
                  </CButton>
                )}
                &nbsp;{' '}
                {editMode ? (
                  <CButton color="danger" size="sm" variant="outline" onClick={handleClose}>
                    Close
                  </CButton>
                ) : null}
              </CCol>
            </CRow>
          </CForm>
        )}
      </CCardBody>
    </CCard>
  )
}

export default PuranoAbedanForm

PuranoAbedanForm.propTypes = {
  editMode: PropTypes.bool,
  handleClose: PropTypes.func,
}

PuranoAbedanForm.defaultProps = {
  editMode: false,
  handleClose: () => console.log('Clicked'),
}
